export const getWarningTypes = (type) => {
    let types = [
        { id: "4GOfflineOver24Hours_CheckWiring", label: "4G Offline Over 24 Hours" },
        { id: "BatteryVoltageLow_CheckWiring", label: "Battery Voltage Low" },
        { id: "CameraTilted_CheckOrientation", label: "Camera Tilted" },
        { id: "DiagnoseTroubleCodeReported_CheckEngineIfItPersist", label: "Diagnose Trouble Code Reported" },
        { id: "DrivingOver18Hours_CheckWiring", label: "Driving Over 18 Hours" },
        { id: "FormatSDCard", label: "Format SD Card" },
        { id: "GPSGapTooLarge_PossiblePowerOrSignalIssue", label: "GPS Gap Too Large" },
        { id: "LowVBUSVoltage_Check5PinConnection", label: "Low VBUS Voltage" },
        { id: "MCUDisconnected_NeedToForceUpdateMCU", label: "MCU Disconnected" },
        { id: "ReplaceSDCard", label: "Replace SD Card" },
        { id: "SIMCardInfoChanged", label: "SIM Card Info Changed" },
        { id: "UnsupportedVideoConfigCombinations_CheckRestrictionsInTheDoc", label: "Unsupported Video Config Combinations" },
        { id: "VinNumChanged_CheckVehicleChanges", label: "Vin Number Changed" },
        { id: "firmwareUpdated", label: "Firmware Updated" },
        { id: "FailedToEnterStandby_CheckDeviceLogs", label: "Check Device Logs" },
    ];
    if (type) {
        return types.find((item) => item.id === type)
    }
    return types;

}

